/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    /* name: 'EHS_module',
    tagColor: 'warning',
    icon: 'FolderIcon',
    i18n: 'EHS_module',
    use_name:true,
    title: 'EHS',
    label:'EHS',
    can:'IU EHS Module',
    submenu: [
      {
        name: 'Dashboard',
        tagColor: 'warning',
        icon: 'PieChartIcon',
        i18n: 'dashboard',
        url: '/ehs/dashboard',
        use_name:false,
        label:'Dashboard'
      }
    ] */
    name: 'MenuItem',
    icon: 'FolderIcon',
    i18n: 'MenItem',
    submenu: [
      {
        name: 'SubMenuItem',
        icon: 'CircleIcon',
        i18n: 'SubMenuItem',
        url: '/ehs/SubMenuItem',
      }
    ]
  } 
]
